module.exports = __webpack_public_path__ + "static/vector-shape11-adb5ebc35b0feea00714f2e1d99949c6.png";